module.exports = __webpack_public_path__ + "img/home_btn.b61dd648.png";